var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.123 4.2793C11.2821 4.2793 11.4353 4.34256 11.5478 4.45508C11.66 4.56756 11.7226 4.71998 11.7226 4.87891V7.70703C11.7226 8.0384 11.4543 8.30664 11.123 8.30664C10.7918 8.30643 10.5243 8.03827 10.5243 7.70703V6.32617L7.30462 9.54492C7.0703 9.77924 6.69128 9.77924 6.45696 9.54492C6.22269 9.3106 6.22266 8.93156 6.45696 8.69727L9.67571 5.47754H8.29485C7.96363 5.47749 7.69541 5.21011 7.69524 4.87891C7.69524 4.54757 7.96353 4.27935 8.29485 4.2793H11.123Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69141 6.45512C8.92572 6.22081 9.30475 6.22081 9.53906 6.45512C9.77318 6.68945 9.77331 7.06853 9.53906 7.30278L6.31934 10.5215H7.70117C8.03233 10.5217 8.29969 10.79 8.2998 11.1211C8.2998 11.4524 8.0324 11.7206 7.70117 11.7207H4.87207C4.71308 11.7207 4.56068 11.6574 4.44824 11.545C4.3359 11.4325 4.27344 11.2801 4.27344 11.1211V8.29302C4.27344 7.96177 4.54087 7.69361 4.87207 7.69341C5.20344 7.69341 5.47168 7.96164 5.47168 8.29302V9.67387L8.69141 6.45512Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowExpand);
export default __webpack_public_path__ + "static/media/arrow-expand.62e5a7b05a35f112aef9e5fd3d38e411.svg";
export { ForwardRef as ReactComponent };